var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.3299268%",
    y1: "17.487%",
    x2: "32.5272275%",
    y2: "89.755%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873f",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418b3d",
    offset: "32.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419637",
    offset: "63.52%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3fa92d",
    offset: "93.19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3fae2a",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.63.154c-.335-.19-.747-.19-1.082 0L.615 5.252c-.34.19-.53.545-.53.923v10.218a1.09 1.09 0 0 0 .531.923l8.933 5.098c.335.19.747.19 1.082 0l8.933-5.098c.34-.19.53-.545.53-.923V6.175a1.09 1.09 0 0 0-.531-.923L10.63.154z",
    id: "B"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.9432495%",
    y1: "55.169%",
    x2: "132.169376%",
    y2: "-18.306%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873f",
    offset: "13.76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54a044",
    offset: "40.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66b848",
    offset: "71.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cc04a",
    offset: "90.81%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.63.154c-.335-.19-.747-.19-1.082 0L.615 5.252c-.34.19-.53.545-.53.923v10.218a1.09 1.09 0 0 0 .531.923l8.933 5.098c.335.19.747.19 1.082 0l8.933-5.098c.34-.19.53-.545.53-.923V6.175a1.09 1.09 0 0 0-.531-.923L10.63.154z",
    id: "D"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4413.77%",
    y1: "13.43%",
    x2: "5327.93%",
    y2: "13.43%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cc04a",
    offset: "9.192%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66b848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54a044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873f",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.389%",
    y1: "49.997%",
    x2: "101.499%",
    y2: "49.997%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cc04a",
    offset: "9.192%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66b848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54a044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873f",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9713.77%",
    y1: "36.21%",
    x2: "27.93%",
    y2: "36.21%",
    id: "G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cc04a",
    offset: "9.192%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66b848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54a044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873f",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-103.861%",
    y1: "50.275%",
    x2: "100.797%",
    y2: "50.275%",
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cc04a",
    offset: "9.192%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66b848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54a044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873f",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "130.613%",
    y1: "-49.3641875%",
    x2: "4.393%",
    y2: "107.701633%",
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873f",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418b3d",
    offset: "32.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419637",
    offset: "63.52%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3fa92d",
    offset: "93.19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3fae2a",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M19.606 17.316l-8.954 5.098a1.29 1.29 0 0 1-.403.126l.17.315 9.93-5.685v-.126l-.255-.42c-.042.294-.233.545-.488.692z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 19)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.47 56.836c-.318 0-.615-.084-.89-.23l-2.822-1.657c-.424-.23-.212-.315-.085-.357.573-.19.68-.23 1.273-.566.064-.042.15-.02.212.02l2.164 1.28c.085.042.19.042.254 0l8.466-4.846c.085-.042.127-.126.127-.23v-9.672c0-.105-.043-.19-.127-.23l-8.466-4.825c-.085-.042-.19-.042-.254 0l-8.466 4.825c-.085.042-.127.147-.127.23v9.672c0 .084.043.19.127.23l2.313 1.322c1.252.63 2.037-.105 2.037-.84v-9.546c0-.126.106-.252.255-.252h1.082c.127 0 .255.105.255.252v9.546c0 1.657-.912 2.623-2.504 2.623-.488 0-.87 0-1.952-.525l-2.228-1.26c-.552-.315-.89-.902-.89-1.532v-9.672c0-.63.34-1.217.89-1.532l8.466-4.846c.53-.294 1.252-.294 1.783 0l8.466 4.846c.552.315.89.902.89 1.532v9.672c0 .63-.34 1.217-.89 1.532l-8.466 4.846a2.19 2.19 0 0 1-.891.189zm2.6-6.65c-3.713 0-4.477-1.678-4.477-3.105 0-.126.106-.252.255-.252h1.103c.127 0 .233.084.233.2.17 1.112.658 1.657 2.907 1.657 1.782 0 2.546-.4 2.546-1.343 0-.545-.212-.944-2.992-1.217-2.313-.23-3.756-.734-3.756-2.56 0-1.7 1.443-2.707 3.862-2.707 2.716 0 4.053.923 4.223 2.937 0 .063-.02.126-.064.19-.043.042-.106.084-.17.084h-1.103c-.106 0-.212-.084-.233-.19-.255-1.154-.912-1.532-2.652-1.532-1.952 0-2.186.67-2.186 1.175 0 .608.276.797 2.907 1.133 2.6.336 3.84.818 3.84 2.623-.02 1.846-1.55 2.895-4.244 2.895z",
    fill: "#539e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 19.008c0-.378-.212-.734-.552-.923l-8.997-5.12c-.15-.084-.318-.126-.488-.147h-.085c-.17 0-.34.063-.488.147l-8.997 5.12c-.34.19-.552.545-.552.923l.02 13.763a.52.52 0 0 0 .276.462c.17.105.382.105.53 0l5.347-3.02c.34-.19.552-.545.552-.923v-6.44c0-.378.212-.734.552-.923l2.27-1.3c.17-.105.36-.147.552-.147a.92.92 0 0 1 .531.147l2.27 1.3c.34.19.552.545.552.923v6.44c0 .378.212.734.552.923l5.347 3.02c.17.105.382.105.552 0a.52.52 0 0 0 .276-.462l-.02-13.763zM63.445.063a.59.59 0 0 0-.531 0c-.17.105-.276.273-.276.46v13.637c0 .126-.064.252-.19.336a.41.41 0 0 1-.382 0l-2.25-1.28c-.335-.19-.747-.19-1.082 0l-8.997 5.14c-.34.19-.552.545-.552.923v10.26c0 .378.212.734.552.923l8.997 5.14c.335.19.747.19 1.082 0l8.997-5.14c.34-.19.552-.545.552-.923V3.965c0-.4-.212-.755-.552-.944L63.445.063zm-.827 26.1c0 .105-.042.19-.127.23l-3.077 1.762c-.087.042-.19.042-.276 0l-3.077-1.762c-.085-.042-.127-.147-.127-.23v-3.525c0-.105.042-.19.127-.23l3.077-1.762c.087-.042.19-.042.276 0l3.077 1.762c.085.042.127.147.127.23v3.525zm30.767-3.61c.34-.19.53-.545.53-.923v-2.497a1.09 1.09 0 0 0-.531-.923l-8.933-5.12c-.335-.19-.747-.19-1.082 0l-8.997 5.14c-.34.19-.552.545-.552.923v10.26c0 .378.212.734.552.923l8.933 5.035c.34.19.743.19 1.06 0l5.41-2.98a.52.52 0 0 0 .276-.462.52.52 0 0 0-.276-.462l-9.04-5.14c-.17-.105-.276-.273-.276-.46v-3.2a.52.52 0 0 1 .276-.462l2.822-1.595c.17-.105.383-.105.552 0l2.822 1.595c.17.105.276.273.276.462v2.518a.52.52 0 0 0 .276.461c.17.105.382.105.552 0l5.347-3.084z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.773 22.07c.064-.042.148-.042.212 0l1.72.986c.064.042.106.105.106.19v1.972a.22.22 0 0 1-.106.189l-1.72.986c-.064.042-.148.042-.212 0l-1.72-.986a.22.22 0 0 1-.106-.189v-1.972c0-.084.042-.147.106-.19l1.72-.986z",
    fill: "#539e43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.614 12.979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.63.154c-.335-.19-.747-.19-1.082 0L.615 5.252c-.34.19-.53.545-.53.923v10.218a1.09 1.09 0 0 0 .531.923l8.933 5.098c.335.19.747.19 1.082 0l8.933-5.098c.34-.19.53-.545.53-.923V6.175a1.09 1.09 0 0 0-.531-.923L10.63.154z",
    fill: "url(#A)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "K",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.585 5.252L10.6.154C10.52.1 10.43.075 10.334.05L.276 17.085c.083.1.184.186.297.252l8.976 5.098c.255.147.552.19.827.105L19.82 5.462a1.11 1.11 0 0 0-.234-.21z",
    fill: "url(#C)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M9.25-1.713l-.127.063h.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.606 17.316c.255-.147.446-.4.53-.67L10.29.03c-.255-.042-.53-.02-.764.126L.615 5.232l9.612 17.33a1.49 1.49 0 0 0 .403-.126l8.976-5.12z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M20.434 17.15l-.064-.105v.147l.064-.042z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    fill: "url(#I)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs);
export default __webpack_public_path__ + "static/media/NodeJS.c6a5b4b1af31ada80376b5edf77d2ed9.svg";
export { ForwardRef as ReactComponent };